import { render, staticRenderFns } from "./chatBot.vue?vue&type=template&id=291f0be6"
import script from "./chatBot.vue?vue&type=script&lang=js"
export * from "./chatBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports